import { render, staticRenderFns } from "./VolumeTiers.vue?vue&type=template&id=e2799c52&scoped=true"
import script from "./VolumeTiers.vue?vue&type=script&lang=js"
export * from "./VolumeTiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2799c52",
  null
  
)

export default component.exports